import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'nsips-patient-list',
  data: function () {
    return {
      shopId: null,
      patientId: null,
      patientName: null,
      nsPatientCode: null,
      nsPatientName: null,
      searchPatientName: null,
      patientLoading: true,
      nsPatientLoading: true,
      firstLoading: true,
      selectedPatientCode: null
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created: function () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.search()
    if(this.$router.currentRoute.query.patient_code != null && this.$router.currentRoute.query.patient_name != null){
      this.nsPatientCode = this.$router.currentRoute.query.patient_code
      this.nsPatientName = this.$router.currentRoute.query.patient_name
    }
    utils.scrollBottomSearchEvent(this.getPatients, true, 'button.next-page-search-btn')
  },
  computed: {
    shops () {
      return this.$store.getters.shops
    },
    patients () {
      return this.$store.getters.patients
    },
    nsPatients () {
      return this.$store.getters.ns_patients
    },
    nextPage () {
      return this.$store.getters.patientsNextPage
    },
    currentPage () {
      return this.$store.getters.patientsCurrentPage
    }
  },
  methods: {
    search: function () {
      self = this
      this.$store.dispatch('SHOP_SEARCH', {data: { }, callback: () => {
        self.getPatients(false)
        self.getNsPatients()
      }})
    },
    getPatients: function (readMore) {
      var self = this
      var url = null
      var page = null
      var clear = true

      if (readMore) {
        url = self.$store.getters.patientsNextPage
      }

      var data = {
        'shop_id': self.shopId,
        'patient_name': self.searchPatientName
      }

      self.patientLoading = true
      self.$store.dispatch('PATIENT_SEARCH', { url: url, data: data, callback: () => {
        self.patientLoading = false
      }})
    },
    getNsPatients: function () {
      self = this
      if (self.firstLoading) {
        self.nsPatientLoading = true
        this.$store.dispatch('NS_PATIENTS_SEARCH', { data: { 'shop_id': this.shopId }, callback: () => {
          self.nsPatientLoading = false
        }})
        self.firstLoading = false
      }
    },
    matching: function () {
      self = this
      self.firstLoading = true
      this.$store.dispatch('NS_PATIENT_MATCHING', { data: { 'patient_id': this.patientId, 'ns_patient_code': this.nsPatientCode, 'shop_id': this.shopId }, callback: () => {
        self.search()
      }})
    },
    createPatient: function () {
      if (this.nsPatientCode !== null) {
        self = this
        this.$router.push({ path: '/plans/create', query: { nsips: 'patient', patient_code: this.nsPatientCode, shop_id: this.shopId } })
      } else {
        return false
      }
    },
    createOutPatient: function () {
      if (this.nsPatientCode !== null) {
        self = this
        this.$router.push({ path: '/outpatients/edit', query: { nsips: 'patient', patient_code: this.nsPatientCode, shop_id: this.shopId } })
      } else {
        return false
      }
    },
    setNsPatientName: function (nsPatientName) {
      this.nsPatientName = nsPatientName
    },
    setPatientData: function (id, patientName) {
      this.patientId = id
      this.patientName = patientName
    },
    unsetPatientData: function () {
      this.patientId = null
      this.patientName = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/nsips-patient-list.js